import React from "react"
import "./maintenance-page.scss"

const MaintenancePage = () => {
  const logoPath = process.env.GATSBY_LOGO_PATH || "/imgs/logo.gif"
  return (
    <div className="maintenance-page">
      <div className="maintenance-page__container">
        <div className="maintenance-page__logo-wrapper">
          <img
            src={logoPath}
            alt="EFPA España"
            className="maintenance-page__logo"
            onError={e => {
              e.target.style.display = "none"
            }}
          />
        </div>

        <div className="maintenance-page__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="30" stroke="#112149" strokeWidth="3" />
            <path
              d="M32 18v18M32 42v4"
              stroke="#112149"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <h1 className="maintenance-page__title">Plataforma en mantenimiento</h1>

        <p className="maintenance-page__description">
          Estamos trabajando para mejorar tu experiencia. La plataforma no está
          disponible temporalmente. Disculpa las molestias.
        </p>

        <p className="maintenance-page__subtitle">
          Volveremos en breve. Gracias por tu paciencia.
        </p>

        <div className="maintenance-page__bar" />
      </div>
    </div>
  )
}

export default MaintenancePage
